/**
 * Czy zadanie synchronizacji/eksportu jest „w toku" z punktu widzenia okna.
 *
 * Okna integracji blokują zamknięcie tłem i Esc, dopóki zadanie trwa (zamknięcie ukryłoby
 * postęp). Blokada musi się jednak ZAWSZE zwolnić, więc zadanie przestaje być „w toku", gdy:
 *   - minął limit czasu okna (`timedOut`),
 *   - odpytywanie o stan zadania kończy się błędem (`pollFailed`; bez tego okno wisiałoby
 *     zablokowane aż do limitu czasu przy stałym 404 lub braku sieci),
 *   - zadanie ma stan końcowy (`completed` / `failed`).
 * Brak danych zadania (`null`) = jeszcze czekamy na pierwszą odpowiedź.
 */
export function isJobInFlight(
  job: { status: string } | null,
  timedOut: boolean,
  pollFailed: boolean,
): boolean {
  if (timedOut || pollFailed) return false;
  return !job || job.status === 'pending' || job.status === 'running';
}
